<template>
    <div id="address-verify">
        <div id="address-verify-header">
        </div>
        <div class="receipt-info">
            <div class="receipt-info-item">
                <span class="label">收货人：</span>
                <span class="value">{{ consignee }}</span>
            </div>
            <div class="receipt-info-item">
                <span class="label">手机号：</span>
                <span class="value">{{ mobile }}</span>
            </div>
            <div class="receipt-info-item">
                <span class="label">收货地址：</span>
                <span class="value">{{ `${city}${area}${address}` }}</span>
            </div>
        </div>
        <div class="precautions">
            <span class="important">注意事项：</span>
            <div>请仔细核实上面地址是否正确，如因地址不正确或无法联系到收货人导致奖品派发不成功的，将视为放弃奖品，地址一经确认无法修改。</div>
        </div>
        <div class="confirm-btn" @click="confirmBtn">
            确认领取
        </div>
        <div class="back-btn" @click="backBtn">返回修改</div>

        <exchange-prize-dialog v-if="tipDialogVisible" class="tip-dialog" width="80%">
            <div class="tip-title">提示</div>
            <div class="tip-context">领取成功！感谢您的参与！礼品预计在{{activityShipDate}}之后由工作人员联系您进行配送！</div>
            <div class="tip-button">
                <button class="tip-ok" @click="handleTipOk">确认</button>
            </div>
        </exchange-prize-dialog>

        <exchange-prize-dialog v-if="errorTipDialogVisible" class="tip-dialog" width="80%">
            <div class="tip-title">提示</div>
            <div class="tip-context">{{ errorTipMessage }}</div>
            <div class="tip-button">
                <button class="tip-ok" @click="handleErrorTipOk">确认</button>
            </div>
        </exchange-prize-dialog>

        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
    </div>
</template>

<script>

import ExchangePrizeDialog from "@/components/ExchangePrizeDialog";
import {AddActivityAddress} from "../../api/Activity";
import {isChinese} from "../../unitls";

export default {
    name: "VerifyAddress",
    components: {
        ExchangePrizeDialog
    },
    data() {
        return {
            consignee: this.$route.query.consignee,
            mobile: this.$route.query.mobile,
            city: this.$route.query.city,
            area: this.$route.query.area,
            address: this.$route.query.address,
            tipDialogVisible: false,
            errorTipDialogVisible: false,
            errorTipMessage: '',
            toastShow: false,
            toastText: '',
            activityShipDate:''
        }
    },

    mounted() {
        console.log(this.$route.query);
    },

    methods: {
        handleTipOk() {
            this.$router.push({path: '/mine'})
        },

        handleErrorTipOk() {
            this.errorTipDialogVisible = false;
        },

        toast(e) {
            let _that = this;
            this.toastText = e;
            this.toastShow = true;
            setTimeout(function () {
                _that.toastShow = false;
                if (_that.isSuccess) {
                    _that.$router.go(-1);
                }
            }, 1000)
        },

        confirmBtn() {
            if (this.consignee === '') {
                this.toast('请输入收货人姓名');
                return;
            }
            if (!isChinese(this.consignee)) {
                this.toast('收货人姓名必须是汉字');
                return;
            }
            if (this.consignee.trim().length < 2) {
                this.toast('收货人姓名必须在2-15位');
                return;
            }
            if (this.mobile === '') {
                this.toast('请输入电话号码');
                return;
            }

            let telReg = /^1[3456789]\d{9}$/;
            if (!telReg.test(this.mobile)) {
                this.toast("请输入正确的电话号码");
                return;
            }
            if (this.city === '' || this.area === '') {
                this.toast('请选择地址');
                return;
            }
            if (this.address === '') {
                this.toast('请输入详细地址');
                return;
            }
            if (this.isDefault === '') {
                this.isDefault = false;
            }

            if (this.distributionCenterId === '' || this.lat === '') {
                this.toast('地址所属配送范围无效，请重新选择');
                return;
            }

            AddActivityAddress(this.consignee, this.city, this.area, this.address, this.mobile).then((response) => {
                if (response.code === this.$API_CODE.OK) {
                    this.tipDialogVisible = true;
                    this.activityShipDate = response.data.activityShipDate;
                } else {
                    this.errorTipDialogVisible = true;
                    this.errorTipMessage = response.message;
                }
            })
        },

        backBtn() {
            this.$router.back();
        },
    }
}
</script>

<style scoped lang="scss">
#address-verify {
    height: 100%;
    width: 100%;
    position: absolute;
    background: #fdf9f7;

    //header区域
    #address-verify-header {
        height: 6rem;
        line-height: 35px;
        background: url("../../assets/detail.png") no-repeat;
        background-size: 100% 6rem;
        width: 100%;

        .receive-address-title {
            color: white;
            float: right;
            margin-right: 20px;
            margin-top: 2rem;
            font-weight: bold;
            font-size: 1rem;
        }
    }
}

/* 收货信息容器 */
.receipt-info {
    padding: 10px;
    background: #fff;
    border-radius: 10px;
    margin: 10px;
    box-shadow: 0 4rpx 12rpx rgba(0, 0, 0, 0.05);
}

/* 每项信息 */
.receipt-info-item {
    padding: 5px 0;
    font-size: 15px;
    display: flex;
    align-items: center;
    text-align: left;
}

/* 标签文字 */
.label {
    color: #666;
    width: 80px;
}

/* 值文字 */
.value {
    color: #333;
    flex: 1;
}

/* 注意事项 */
.precautions {
    padding: 10px;
    margin: 10px;
    background: #fffbe6;
    border-radius: 10px;
    font-size: 15px;
    color: #666;
    line-height: 1.6;
    text-align: left;
}

/* 重要提示文字 */
.important {
    color: #faad14;
    font-weight: bold;
}

.confirm-btn {
    position: fixed;
    z-index: 1;
    left: 0;
    bottom: 0;
    background: #ea2d53;
    width: 50%;
    font-size: 1rem;
    color: #FFFFFF;
    border: 1px solid #ea2d53;
    height: 3rem;
    line-height: 3rem;
    text-align: center;
}

.back-btn {
    position: fixed;
    z-index: 1;
    right: 0;
    bottom: 0;
    background: #fdf9f7;
    width: 50%;
    font-size: 1rem;
    font-weight: bold;
    color: #ea2d53;
    border: 1px solid #ea2d53;
    height: 3rem;
    line-height: 3rem;
    text-align: center;
}

#address-verify .tip-dialog{
    ::v-deep .dialog-body {
        padding-top: 15px !important;
        padding-bottom: 15px !important;
    }
}

#address-verify .tip-dialog .tip-title {
    color: #ea2d53;
    font-weight: bold;
    text-align: center;
    font-size: 18px;
}

#address-verify .tip-dialog .tip-context {
    text-align: left;
    margin: 15px;
    line-height: 1.6;
    word-wrap: break-word;
    word-break: break-all;
    font-size: 15px;
    color: #666;
}

#address-verify .tip-dialog .tip-button {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-top: 40px;
}

#address-verify .tip-dialog .tip-button button {
    min-height: 30px;
    line-height: 1.4;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: normal;
    word-break: break-all;
    font-size: 14px;
    width: 50%;
}

#address-verify .tip-dialog .tip-button .tip-cancel {
    background: #f5f5f5;
    color: #666;
}

#address-verify .tip-dialog .tip-button .tip-ok {
    background: #ea2d53;
    color: white;
}

.toast {
    position: fixed;
    z-index: 2000;
    left: 50%;
    top: 50%;
    transition: all .5s;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    -o-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    text-align: center;
    border-radius: 5px;
    color: #FFF;
    background: rgba(17, 17, 17, 0.7);
    padding: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
}
</style>
